(function () {
  if (window.__pdpBus) return;
  window.__pdpBus = 1;
  var booted = false;

  function boot() {
    if (booted) return;
    booted = true;

    var cfgEl = document.querySelector('[data-pdp-config]');
    var cfg = {};
    if (cfgEl) { try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = {}; } }
    var variants = cfg.variants || [];
    var moneyFmt = cfg.moneyFormat || '${{amount}}';
    var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function qsa(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }

    function money(cents) {
      var amount = cents / 100;
      var withCents = amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
      var noCents = Math.round(amount).toString().replace(/\d(?=(\d{3})+$)/g, '$&,');
      return moneyFmt
        .replace('{{amount}}', withCents)
        .replace('{{amount_with_comma_separator}}', withCents.replace('.', ','))
        .replace('{{amount_no_decimals}}', noCents)
        .replace('{{amount_no_decimals_with_comma_separator}}', noCents);
    }

    var state = { index: Math.max(0, variants.findIndex(function (v) { return v.id === cfg.selectedId; })) };
    if (state.index < 0) state.index = 0;
    function cur() { return variants[state.index] || variants[0] || {}; }

    /* ---------- VARIANT SELECT ---------- */
    var selectAttrs = ['data-pdp-size', 'data-pdp-scale', 'data-pdp-row'];
    function select(i) { if (i < 0 || i >= variants.length) return; state.index = i; render(); }
    selectAttrs.forEach(function (attr) {
      qsa('[' + attr + ']').forEach(function (el) {
        if (el.dataset.pdpBound) return; el.dataset.pdpBound = '1';
        el.addEventListener('click', function () { select(parseInt(el.getAttribute(attr), 10)); });
      });
    });

    /* ---------- GALLERY ---------- */
    var thumbs = qsa('[data-pdp-thumb]');
    thumbs.forEach(function (t) {
      if (t.dataset.pdpBound) return; t.dataset.pdpBound = '1';
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-pdp-thumb-src');
        var alt = t.getAttribute('data-pdp-thumb-alt') || '';
        qsa('[data-pdp-main-img]').forEach(function (img) { if (src) { img.src = src; img.alt = alt; } });
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    /* ---------- STICKY ---------- */
    var sticky = document.querySelector('[data-pdp-sticky]');
    if (sticky && !sticky.dataset.pdpBound) {
      sticky.dataset.pdpBound = '1';
      var footerVisible = false;
      var onScroll = function () {
        var past = (window.scrollY || window.pageYOffset || 0) > 560;
        if (past && !footerVisible) sticky.classList.add('is-visible');
        else sticky.classList.remove('is-visible');
      };
      var footer = document.querySelector('.shopify-section--footer, footer');
      if (footer && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          footerVisible = entries[0].isIntersecting;
          onScroll();
        }, { rootMargin: '0px 0px 80px 0px' }).observe(footer);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* ---------- TOAST ---------- */
    function toast(msg) {
      var t = document.querySelector('[data-pdp-toast]');
      if (!t) return;
      var m = t.querySelector('[data-pdp-toast-msg]');
      if (m) m.textContent = msg;
      t.classList.add('is-visible');
      if (t._tm) clearTimeout(t._tm);
      t._tm = setTimeout(function () { t.classList.remove('is-visible'); }, 2600);
    }

    /* ---------- CART HELPERS ---------- */
    function afterAdd(redirect) {
      fetch(routeRoot + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'pdp:add', cart: cart } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (redirect) { window.location.href = routeRoot + 'cart'; return; }
          var drawer = document.getElementById('cart-drawer') || document.querySelector('cart-drawer, .cart-drawer');
          if (drawer && typeof drawer.show === 'function') drawer.show();
          else if (drawer && typeof drawer.open === 'function') drawer.open();
          else document.documentElement.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
        })
        .catch(function () {});
    }
    function postItems(items, onDone) {
      return fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (res) {
          if (!r.ok) { toast(res.description || res.message || 'Sorry, that could not be added to your cart.'); throw res; }
          if (onDone) onDone(res);
          return res;
        });
      });
    }

    /* ---------- ADD-ONS KIT ---------- */
    var addonEls = qsa('[data-pdp-addon]');
    var kitTotalEl = document.querySelector('[data-pdp-kit-total]');
    var kitCountEl = document.querySelector('[data-pdp-kit-count]');
    var kitBtn = document.querySelector('[data-pdp-kit-add]');
    function updateKit() {
      var total = 0, count = 0;
      addonEls.forEach(function (el) {
        if (el.classList.contains('is-checked')) { total += parseInt(el.getAttribute('data-pdp-addon-price'), 10) || 0; count += 1; }
      });
      if (kitTotalEl) kitTotalEl.textContent = money(total);
      if (kitCountEl) kitCountEl.textContent = count + (count === 1 ? ' item' : ' items');
      if (kitBtn) kitBtn.disabled = count === 0;
    }
    addonEls.forEach(function (el) {
      if (!el.getAttribute('data-pdp-addon-variant')) { el.style.display = 'none'; return; }
      if (el.dataset.pdpBound) return; el.dataset.pdpBound = '1';
      el.addEventListener('click', function () { el.classList.toggle('is-checked'); updateKit(); });
    });
    if (kitBtn) {
      kitBtn.addEventListener('click', function () {
        var items = [];
        addonEls.forEach(function (el) {
          if (el.classList.contains('is-checked')) {
            var vid = parseInt(el.getAttribute('data-pdp-addon-variant'), 10);
            if (vid) items.push({ id: vid, quantity: 1 });
          }
        });
        if (!items.length) return;
        kitBtn.disabled = true;
        postItems(items, function () {
          toast(items.length + (items.length === 1 ? ' item' : ' items') + ' added to your test setup');
          afterAdd(false);
        }).catch(function () {}).finally(function () { kitBtn.disabled = false; });
      });
    }
    if (addonEls.length) updateKit();

    /* ---------- RENDER ---------- */
    function setText(sel, txt) { qsa(sel).forEach(function (el) { el.textContent = txt; }); }
    function render() {
      var v = cur(), i = state.index;
      selectAttrs.forEach(function (attr) {
        qsa('[' + attr + ']').forEach(function (el) { el.classList.toggle('is-active', parseInt(el.getAttribute(attr), 10) === i); });
      });
      qsa('[data-pdp-variant-id]').forEach(function (el) { if (v.id) el.value = v.id; });

      setText('[data-pdp-cur-size]', v.sizeLabel || v.title || '');
      setText('[data-pdp-cur-price]', money(v.price || 0));
      setText('[data-pdp-cur-fit]', v.fit || cfg.defaultFit || '');
      setText('[data-pdp-cur-bestfor]', v.bestFor || '');
      setText('[data-pdp-cur-note]', v.note || '');
      setText('[data-pdp-cur-quarter]', money(Math.round((v.price || 0) / 4)));
      setText('[data-pdp-cur-exgst]', money(Math.round((v.price || 0) / 1.1)));

      qsa('[data-pdp-cur-was]').forEach(function (el) {
        if (v.compareAt && v.compareAt > v.price) { el.textContent = money(v.compareAt); el.style.display = ''; }
        else el.style.display = 'none';
      });
      qsa('[data-pdp-cur-save]').forEach(function (el) {
        if (v.compareAt && v.compareAt > v.price) { el.textContent = 'SAVE ' + money(v.compareAt - v.price); el.style.display = ''; }
        else el.style.display = 'none';
      });

      var avail = v.available !== false;
      qsa('[data-pdp-stock]').forEach(function (el) {
        el.classList.toggle('is-oos', !avail);
        var lbl = el.querySelector('[data-pdp-stock-lbl]');
        if (lbl) lbl.textContent = avail ? 'In stock' : 'Out of stock';
      });
      qsa('[data-pdp-buyrow]').forEach(function (el) { el.classList.toggle('is-sold-out', !avail); });
      qsa('[data-pdp-qty-wrap]').forEach(function (el) { el.hidden = !avail; });
      qsa('[data-pdp-atc] .button').forEach(function (btn) {
        btn.disabled = !avail;
        btn.classList.toggle('button--subdued', !avail);
        var lbl = btn.querySelector('.atc-cart-label');
        if (lbl) lbl.textContent = avail ? (cfg.addLabel || lbl.textContent) : (cfg.soldOutLabel || lbl.textContent);
      });
    }
    if (variants.length) render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function () { booted = false; boot(); });
})();
